module.exports = __webpack_public_path__ + "static/img/logoRET.79454f0c.png";